import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_2 = {
  key: 1,
  class: "view-container"
}
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "alerts-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_MainNavBar = _resolveComponent("MainNavBar")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_FooterBar = _resolveComponent("FooterBar")!
  const _component_MobileMainNavBar = _resolveComponent("MobileMainNavBar")!
  const _component_FeedbackAlert = _resolveComponent("FeedbackAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_progress_circular, {
            color: "#ffd139",
            indeterminate: "",
            size: 64,
            width: 6
          }),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('i18n.preparingContent')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_MainNavBar, { onNavigate: _ctx.changeActiveTab }, null, 8, ["onNavigate"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_RouterView)
          ]),
          _createVNode(_component_FooterBar),
          _createVNode(_component_MobileMainNavBar)
        ])),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
        return (_openBlock(), _createBlock(_component_FeedbackAlert, {
          key: alert.id,
          text: alert.text,
          feedbackType: alert.feedbackType,
          onCloseAlert: ($event: any) => (_ctx.removeAlert(alert.id))
        }, null, 8, ["text", "feedbackType", "onCloseAlert"]))
      }), 128))
    ])
  ], 64))
}